import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  sidebarShow: true,

  fileHistoryModal: {
    show: false,
    title: '',
    files: [],
    canEdit: false,
    fileType: '',
  },
}

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    toggleSidebar(state) {
      state.sidebarShow = !state.sidebarShow
    },

    setFileHistoryModal(state, action) {
      state.fileHistoryModal = {
        ...state.fileHistoryModal,
        ...action.payload,
      }
    },
  },
})

export const { toggleSidebar, setFileHistoryModal } = uiSlice.actions
export default uiSlice.reducer

export const uiSelector = (state) => state.ui
